import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../util/pageTitles';
import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withRouter } from '../../util/withRouter';
import { Button, Tooltip, OverlayTrigger, Dropdown, DropdownButton, Form} from 'react-bootstrap';
import CheckBox from '../../components/Checkbox/Checkbox';

import Confirm from '../../components/Confirm/Confirm';
import { listAll as getDashboards } from '../../components/DashboardSelector/DashboardSelectorActions';
import { listAll as getStreams } from '../../modules/ReportConfig/ReportActions';
import { listAll as getPortfolios } from '../../modules/Portfolios/PortfolioActions';
import { getUsers, deleteUser, rejectRequest, resendInvitation, transferOwnership, exportCsv } from './UsersActions';

import pagination from '../../util/pagination';
import throttle from '../../util/throttle';
import { PERMISSIONS, getPremiumStatus } from '../../util/permissions';

import Loading from '../../components/Loading/Loading';
import AddUser from './components/AddUser';
import Header from '../../components/Header/Header';

import arrowSortIcon from '../../assets/img/arrow-down.svg';
import downloadIcon from '../../assets/img/download.svg';
import peopleIcon from '../../assets/img/people.svg';
import mailIcon from '../../assets/img/mail.svg';
import dashboardIcon from '../../assets/img/dashboard.svg';
import editIcon from '../../assets/img/edit.svg';
import transferIcon from '../../assets/img/transfer.svg';
import deleteIcon from '../../assets/img/delete.svg';

import warningIcon from '../../assets/images/warning.svg';

import createIcon from '../../assets/img/create-permission.svg';
import viewIcon from '../../assets/img/view-permission.svg';
import fullIcon from '../../assets/img/full-permission.svg';

import { INTEGRATIONS, beautifyHost } from '../../util/integrations';

// Import Style
import './Users.scss';
import _ from 'lodash';

export class Users extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      filter: 'all',
      sort: '-joinedOn',
      search: '',
      page: 1,
      checked: [],
      checkedAll: false,
      filterOptions: [
        {
          name: 'All',
          value: 'all'
        },
        {
          name: 'Manage billing',
          value: 'billing'
        },
        {
          name: 'Manage users',
          value: 'users'
        },
        {
          name: 'Manage dashboards (full access)',
          value: 'dashboards-full'
        },
        {
          name: 'Manage dashboards (view access only)',
          value: 'dashboards-view'
        },
        {
          name: 'Create dashboards',
          value: 'dashboards-create'
        },
        {
          name: 'Dashboards permissions only',
          value: 'dashboards-partial'
        },
        {
          name: 'Manage streams (full access)',
          value: 'streams-full'
        },
        {
          name: 'Manage streams (view access only)',
          value: 'streams-view'
        },
        {
          name: 'Create streams',
          value: 'streams-create'
        },
        {
          name: 'Streams permissions only',
          value: 'streams-partial'
        },
        {
          name: 'Manage portfolios (full access)',
          value: 'portfolios-full'
        },
        {
          name: 'Manage portfolios (view access only)',
          value: 'portfolios-view'
        },
        {
          name: 'Create portfolios',
          value: 'portfolios-create'
        },
        {
          name: 'Portfolios permissions only',
          value: 'portfolios-partial'
        }
      ],
      sortName: [
        {
          name: 'Name: A to Z',
          value: 'name'
        },
        {
          name: 'Name: Z to A',
          value: '-name'
        }
      ],
      sortJoinedOn: [
        {
          name: 'Joined on: newest first',
          value: '-joinedOn'
        },
        {
          name: 'Joined on: oldest first',
          value: 'joinedOn'
        }
      ],
      sortLastActiveOn: [
        {
          name: 'Last active on: newest first',
          value: '-lastActiveOn'
        },
        {
          name: 'Last active on: oldest first',
          value: 'lastActiveOn'
        }
      ],
      sortEmail: [
        {
          name: 'Email: A to Z',
          value: 'email'
        },
        {
          name: 'Email: Z to A',
          value: '-email'
        }
      ],
      sortDashboards: [
        {
          name: 'Access rights: least',
          value: 'dashboards'
        },
        {
          name: 'Access rights: most',
          value: '-dashboards'
        }
      ]
    };

    this.getUsersThrottled = throttle(this.getUsers, 500, this);
    this.exportCsvThrottled = throttle(this.exportCsv, 500, this);
  }

  componentDidMount() {
    if (!this.props.dashboards.length) {
      this.props.getDashboards();
    }
    if (!this.props.streams.length) {
      this.props.getStreams();
    }
    if (!this.props.portfolios.length) {
      this.props.getPortfolios();
    }
    this.getUsers();
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.users, this.props.users)) {
    }
  }

  gotoDashboards = id => {
    this.props.router.push(`/dashboards${!!id ? `/${id}` : ''}`);
  };

  applyFilter = filter => {
    this.setState({ filter, page: 1, checked: [], checkedAll: false }, this.getUsers);
  };

  applySort = sort => {
    this.setState({ sort, page: 1, checked: [], checkedAll: false }, this.getUsers);
  };

  onSearch = e => {
    this.setState({ search: e.target.value, page: 1, checked: [], checkedAll: false }, this.getUsersThrottled);
  };

  goto = page => {
    if (page < 1) {
      page = 1;
    }

    this.setState({ page, checked: [], checkedAll: false }, this.getUsers);
  };

  getUsers = () => {
    const { filter, sort, search, page } = this.state;
    this.props.getUsers({ filter, sort, search, page });
  };

  rejectRequest = id => {
    this.props.rejectRequest(id);
  };

  toggleFilter = () => {
    document.getElementById('filter-content').classList.toggle('shown');
  };

  // Helper to check if user is owner in any tenant account connection
  isOwnerInAnyAccount = (u) => {
    return u.role === 'owner' || (u.connections && u.connections.some(c => c.role === 'owner'));
  };

  onToggle = id => {
    const { checked } = this.state;
    const { users } = this.props;

    const index = _.indexOf(checked, id);
    if (index > -1) {
      checked.splice(index, 1);
    } else {
      checked.push(id);
    }

    const checkedAll = _(users)
      .filter(u => {
        return !u.pending && this.props.userId !== u.userId && !this.isOwnerInAnyAccount(u);
      })
      .map(u => _.indexOf(checked, u.userId) > -1)
      .every();
    this.setState({ checked, checkedAll });
  };

  onToggleAll = () => {
    const { checkedAll } = this.state;
    const checked = checkedAll
      ? []
      : _(this.props.users)
          .filter(u => {
            return !u.pending && this.props.userId !== u.userId && !this.isOwnerInAnyAccount(u);
          })
          .map(u => u.userId)
          .value();
    this.setState({ checked, checkedAll: !checkedAll });
  };

  renderSelected = type => {
    const selected = _.find(this.state[type + 'Options'], {
      value: this.state[type]
    });
    return selected ? selected.name : '';
  };

  renderPagination = () => {
    const pages = pagination(this.props.total, this.props.page, 20, 5);

    if (pages.totalPages < 2) {
      return <div></div>;
    }

    return (
      <ul className="pagination">
        {pages.currentPage > 1 && (
          <li aria-label="First" onClick={() => this.goto(1)}>
            <a role="button" href="#">
              «
            </a>
          </li>
        )}
        {pages.currentPage > 1 && (
          <li aria-label="Prev" onClick={() => this.goto(pages.currentPage - 1)}>
            <a role="button" href="#">
              ‹
            </a>
          </li>
        )}
        {pages.pages.map((p, i) => {
          return (
            <li className={p === pages.currentPage && 'active'} key={i} onClick={() => this.goto(p)}>
              <a role="button" href="#">
                {p}
              </a>
            </li>
          );
        })}
        {pages.currentPage < pages.totalPages && (
          <li aria-label="Next" onClick={() => this.goto(pages.currentPage + 1)}>
            <a role="button" href="#">
              ›
            </a>
          </li>
        )}
        {pages.currentPage < pages.totalPages && (
          <li aria-label="Last" onClick={() => this.goto(pages.totalPages)}>
            <a role="button" href="#">
              »
            </a>
          </li>
        )}
      </ul>
    );
  };

  exportCsv = () => {
    const { filter, sort, search } = this.state;
    this.props.exportCsv({ filter, sort, search, page: 'all' });
  };

  handleExport = ev => {
    ev.preventDefault();
    ev.stopPropagation();
    ev.target.blur();
    this.exportCsvThrottled();
  };

  renderConnections(user) {
    if (user && user.connections) {

      const groups = _(user.connections)
        .groupBy('platform')
        .toPairs()
        .value();

      return (
        <div className="connections">
          {
            _.map(groups, ([platform, connections]) => (
              <OverlayTrigger
                key={platform}
                placement="bottom"
                overlay={
                  <Tooltip className="tooltip_dark">
                    {INTEGRATIONS[platform].name}
                    {
                      _.map(connections, c => (
                        <React.Fragment key={c._id}>
                          <br/>
                          {beautifyHost(c[INTEGRATIONS[platform].field])}
                        </React.Fragment>
                      ))
                    }
                  </Tooltip>
                }>
                <div>
                  <img key={platform} className="connection_icon" src={INTEGRATIONS[platform].icon} alt="#"/>
                </div>
              </OverlayTrigger>
            ))
          }
        </div>
      )
    } else {
      return (
        <div className="connections"></div>
      )
    }
  }

  renderAwaitingUsers() {
    const { awaiting, user } = this.props;
    return (
      <div className='table-content table-card'>
        <div className='table-filter'>
          <h5>Pending access requests</h5>
        </div>

        <div className='table-scroll custom-height'>
          <table className='table'>
            <thead>
              <tr>
                <th>User</th>
                <th>Email</th>
                <th>Joined on</th>
                <th>Last active</th>
                <th>Access rights</th>
                { user && user.hasTenant && (
                  <th>Connection</th>
                )}
                <th className='width-auto'>Actions</th>
              </tr>
            </thead>
            <tbody>
              {awaiting.map((u, i) => {
                return (
                  <tr key={i}>
                    <td>{u.name || '(no name)'}</td>
                    <td>{u.email || u.invitationEmail}</td>
                    <td>{moment(u.joinedOn).format('D MMM YYYY hh:mm A')}</td>
                    <td>
                      {!u.lastActiveOn ? '-' : moment(u.lastActiveOn).format('D MMM YYYY hh:mm A')}
                    </td>
                    <td>
                      {`Dashboards: ${u.dashboards.length}`}
                    </td>
                    { user && user.hasTenant && (
                      <td>
                        <div className="connections">
                          <img className="connection_icon" src={INTEGRATIONS[u.platform].icon} alt="#"/>
                        </div>
                      </td>
                    )}
                    <td className='width-auto'>
                      <div className='flex'>
                        <AddUser model={u} onClose={this.getUsers}>
                          <Button variant='secondary' size='md'>Grant permissions</Button>
                        </AddUser>
                        <Confirm
                          onConfirm={() => this.rejectRequest(u.userId)}
                          body={
                            <p>
                              Are you sure you want to decline <strong>{u.name}</strong>'s access request?
                            </p>
                          }
                          confirmText="Decline"
                          icon={deleteIcon}
                          title="Decline request"
                        >
                          <Button variant='danger' size='md'>Decline request</Button>
                        </Confirm>

                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  renderAccessGroup(u, entity) {
    return (
      <div key={entity} className='access-group-permission'>
        <OverlayTrigger placement="top"
          overlay={
            <Tooltip className="tooltip_dark max-width-200">
              {u[PERMISSIONS[entity].create] && !u[PERMISSIONS[entity].view] && !u[PERMISSIONS[entity].full] && `Can create new ${PERMISSIONS[entity].label}`}
              {u[PERMISSIONS[entity].view] && !u[PERMISSIONS[entity].create] && !u[PERMISSIONS[entity].full] && `Can view all ${PERMISSIONS[entity].label}`}
              {u[PERMISSIONS[entity].create] && (u[PERMISSIONS[entity].view] && !u[PERMISSIONS[entity].full]) && `Can create and view all ${PERMISSIONS[entity].label}`}
              {u[PERMISSIONS[entity].full] && !u[PERMISSIONS[entity].create] && `Can view and manage all ${PERMISSIONS[entity].label}`}
              {u[PERMISSIONS[entity].full] && u[PERMISSIONS[entity].create] && `Can create, view, and manage all ${PERMISSIONS[entity].label}`}
              {!u[PERMISSIONS[entity].create] && !u[PERMISSIONS[entity].view] && !u[PERMISSIONS[entity].full] && `No global permissions granted for ${PERMISSIONS[entity].label}`}
            </Tooltip>}
          >
          <div className='access-items-permission'>
            <img src={createIcon} alt="create permission" style={{ opacity: u[PERMISSIONS[entity].create] ? 1 : 0.16 }} />
            <img src={viewIcon} alt="view permission" style={{ opacity: (u[PERMISSIONS[entity].view] || u[PERMISSIONS[entity].full]) ? 1 : 0.16 }} />
            <img src={fullIcon} alt="full permission" style={{ opacity: u[PERMISSIONS[entity].full] ? 1 : 0.16 }} />
          </div>
        </OverlayTrigger>
        <span>{
          u[PERMISSIONS[entity].full] ? 'Full' :
            u[PERMISSIONS[entity].view] ? 'View' :
              `${u[entity] ? u[entity].length : 0}`
        }</span> {PERMISSIONS[entity].label}
      </div>
    )
  }

  renderAccessRights(u, premiumStatus) {
    return (
      <div className="access-groups">
        {
          _.map(
            premiumStatus === 'active' ? ['dashboards', 'streams', 'portfolios'] : ['dashboards'],
            (entity) => this.renderAccessGroup(u, entity)
          )
        }
      </div>
    )
  }

  render() {
    const tooltip = (
      <Tooltip id="flowstats-tooltip" className="tooltip_white">
        Pending invitation
      </Tooltip>
    );

    const { userId, users, isLoading, total, awaiting, permissions, user } = this.props;
    const { checked } = this.state;

    const hasDashboardPermissions = permissions && (permissions.manageDashboards || permissions.manageDashboardsViewOnly || (permissions.dashboards && permissions.dashboards.some(p =>
       (p.view || p.edit)
    )));
    const hasDashboards = user.dashboards > 0;
    const canSeeDashboardActivities = hasDashboardPermissions && hasDashboards;

    const canTransferOwner =
      permissions &&
      permissions.manageUsers &&
      permissions.manageBilling &&
      permissions.manageDashboards &&
      permissions.createDashboards;

    const premiumStatus = getPremiumStatus(user);

    return [
      <Header key="1" title="" showHome={true} />,
      <React.Fragment key="2">
        <div id="create-account" className='bg_dashboard'>
          <Helmet>
            <title>{pageTitle('Users')}</title>
          </Helmet>
          <div className='user_container'>
            {awaiting && awaiting.length > 0 && this.renderAwaitingUsers()}

            <div className="action-btn-list">
              {canSeeDashboardActivities && (
                <Link className="btn btn-primary" to="/dashboards">
                  <img src={dashboardIcon} alt='' />
                  See dashboards activity
                </Link>
              )}

              <Button variant='secondary' onClick={this.handleExport}>
                <img src={downloadIcon} alt="" />
                Export
              </Button>

              {checked.length > 1 && (
                <AddUser bulk={true} users={checked}>
                  <Button variant='secondary'>
                    <img src={peopleIcon} alt="" />
                    Grant bulk permissions ({checked.length})
                  </Button>
                </AddUser>
              )}
              <AddUser>
                <Button variant='secondary'>
                  <img src={mailIcon} alt="" />
                  Invite new user
                </Button>
              </AddUser>

            </div>

            <div className='table-content table-card'>
              <div className='table-filter'>
                <h5>Users</h5>
                <div className="u-di form-group">
                  <Form.Group controlId="filter" className="filter-dropdown">
                    <DropdownButton
                      className="form-control-dropdown"
                      id="dropdown-item-button"
                      title={this.renderSelected('filter')}
                    >
                      {this.state.filterOptions.map((f, i) => {
                        return (
                          <Dropdown.Item
                            key={i}
                            as="button"
                            className={this.state.filter === f.value && 'active'}
                            onClick={() => this.applyFilter(f.value)}>
                            {f.name}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </Form.Group>
                  <div className='search-wrap'>
                    <input
                      name="search"
                      placeholder="Search"
                      type="text"
                      id="Search"
                      className="form-control"
                      value={this.state.search}
                      onChange={this.onSearch}
                    />
                  </div>
                </div>
                {/*<div className='filter-button' onClick={this.toggleFilter}>
                  <img alt="filter" src={filterImage} />
                </div>*/}
              </div>

              <div className='table-scroll table-sticky-first-last-cell'>
                <table className='table'>
                  <thead>
                    <tr>
                      <th className='width-auto'>
                        <CheckBox
                          id="check"
                          name=""
                          label=""
                          checked={this.state.checkedAll}
                          onChange={() => this.onToggleAll()}
                        />
                      </th>
                      <th>
                        <div className='flex'>
                          User
                          <Form.Group controlId="sort" className="filter-dropdown">
                            <DropdownButton
                              className="form-control-dropdown-sort"
                              id="dropdown-item-button"
                              title={<img src={arrowSortIcon} alt="#" />}
                            >
                              {this.state.sortName.map((s, i) => {
                                return (
                                  <Dropdown.Item
                                    key={i}
                                    as="button"
                                    className={this.state.sort === s.value && 'active'}
                                    onClick={() => this.applySort(s.value)}
                                  >
                                    {s.name}
                                  </Dropdown.Item>
                                );
                              })}
                            </DropdownButton>
                          </Form.Group>
                        </div>
                      </th>
                      <th>
                        <div className='flex'>
                          Email
                          <Form.Group controlId="sort" className="filter-dropdown">
                            <DropdownButton
                              className="form-control-dropdown-sort"
                              id="dropdown-item-button"
                              title={<img src={arrowSortIcon} alt="#" />}
                            >
                              {this.state.sortEmail.map((s, i) => {
                                return (
                                  <Dropdown.Item
                                    key={i}
                                    as="button"
                                    className={this.state.sort === s.value && 'active'}
                                    onClick={() => this.applySort(s.value)}
                                  >
                                    {s.name}
                                  </Dropdown.Item>
                                );
                              })}
                            </DropdownButton>
                          </Form.Group>
                        </div>
                      </th>
                      <th>
                        <div className='flex'>
                          Joined on
                          <Form.Group controlId="sort" className="filter-dropdown">
                            <DropdownButton
                              className="form-control-dropdown-sort"
                              id="dropdown-item-button"
                              title={<img src={arrowSortIcon} alt="#" />}
                            >
                              {this.state.sortJoinedOn.map((s, i) => {
                                return (
                                  <Dropdown.Item
                                    key={i}
                                    as="button"
                                    className={this.state.sort === s.value && 'active'}
                                    onClick={() => this.applySort(s.value)}
                                  >
                                    {s.name}
                                  </Dropdown.Item>
                                );
                              })}
                            </DropdownButton>
                          </Form.Group>
                        </div>
                      </th>
                      <th>
                        <div className='flex'>
                          Last active
                          <Form.Group controlId="sort" className="filter-dropdown">
                            <DropdownButton
                              className="form-control-dropdown-sort"
                              id="dropdown-item-button"
                              title={<img src={arrowSortIcon} alt="#" />}
                            >
                              {this.state.sortLastActiveOn.map((s, i) => {
                                return (
                                  <Dropdown.Item
                                    key={i}
                                    as="button"
                                    className={this.state.sort === s.value && 'active'}
                                    onClick={() => this.applySort(s.value)}
                                  >
                                    {s.name}
                                  </Dropdown.Item>
                                );
                              })}
                            </DropdownButton>
                          </Form.Group>
                        </div>
                      </th>
                      <th>
                        <div className='flex'>
                          Access rights
                          <Form.Group controlId="sort" className="filter-dropdown">
                            <DropdownButton
                              className="form-control-dropdown-sort"
                              id="dropdown-item-button"
                              title={<img src={arrowSortIcon} alt="#" />}
                            >
                              {this.state.sortDashboards.map((s, i) => {
                                return (
                                  <Dropdown.Item
                                    key={i}
                                    as="button"
                                    className={this.state.sort === s.value && 'active'}
                                    onClick={() => this.applySort(s.value)}
                                  >
                                    {s.name}
                                  </Dropdown.Item>
                                );
                              })}
                            </DropdownButton>
                          </Form.Group>
                        </div>
                      </th>
                      { user && user.hasTenant && (
                        <th>Connections</th>
                      )}
                      <th className='width-auto mw-220 user-actions'>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map((u, i) => {                      
                      const isOwnerInAnyAccount = this.isOwnerInAnyAccount(u);
                      const isDashboardsDisabled = u.pending || !hasDashboards || !hasDashboardPermissions;
                      const isEditDisabled = u.pending || userId === u.userId || isOwnerInAnyAccount;
                      const isTransferDisabled = isOwnerInAnyAccount || u.pending || !canTransferOwner;
                      const isDeleteDisabled = u.isDeleting || userId === u.userId || isOwnerInAnyAccount;
                      return (
                        <tr key={i}>
                          <td className='width-auto'>
                            <CheckBox
                              id="check"
                              name=""
                              label=""
                              disabled={u.pending || userId === u.userId || isOwnerInAnyAccount}
                              checked={_.indexOf(checked, u.userId) > -1}
                              onChange={() => this.onToggle(u.userId)}
                            />
                          </td>
                          <td>
                            {u.pending ? '(no name)' : u.name}
                          </td>
                          <td>
                            <React.Fragment>
                              {u.pending ? (!!u.invitationEmail ? u.invitationEmail : u.email) : u.email}
                              {u.pending && (
                                <OverlayTrigger placement="top" overlay={tooltip}>
                                  <span className='warning'>
                                    <img src={warningIcon} alt="pending" />
                                  </span>
                                </OverlayTrigger>
                              )}
                            </React.Fragment>
                          </td>
                          <td>
                            {moment(u.joinedOn).format('D MMM YYYY hh:mm A')}
                          </td>
                          <td>
                            {u.pending || !u.lastActiveOn ? '-' : moment(u.lastActiveOn).format('D MMM YYYY hh:mm A')}
                          </td>
                          <td>
                            {this.renderAccessRights(u, premiumStatus)}
                          </td>
                          { user && user.hasTenant && (
                            <td>
                              {this.renderConnections(u)}
                            </td>
                          )}
                          <td className='width-auto mw-220 user-actions'>
                            <div className='flex'>
                              <React.Fragment>
                              {u.pending && (
                                  <Confirm
                                    onConfirm={() => this.props.resendInvitation(u._id)}
                                    body={
                                      <p>
                                        Are you sure you want to resend <br />
                                        invitation to <strong>{u.email || u.invitationEmail}</strong>?
                                      </p>
                                    }
                                    confirmText="Resend"
                                    icon={mailIcon}
                                    confirmClass="btn-primary"
                                    title="Resend invitation"
                                    >
                                      <Button variant='secondary' size='md' className='btn-icon'>
                                        <img src={mailIcon} alt='' />
                                      </Button>
                                  </Confirm>
                                )}
                                <Button variant='secondary'  size='md' className={`btn-mw-200 ${isDashboardsDisabled ? 'disabled' : ''}`} onClick={() => this.gotoDashboards(u.userId)} disabled={isDashboardsDisabled}>
                                  {!u.pending && canSeeDashboardActivities ?
                                    <div>
                                      <img src={dashboardIcon} alt='' />
                                      Dashboards activity
                                    </div>
                                    :
                                    <React.Fragment>
                                      {
                                        (!hasDashboardPermissions &&
                                          <OverlayTrigger placement="bottom"  overlay={<Tooltip className="tooltip_white">Dashboard activities are unavailable because you do not have 'Manage Dashboards' or 'View-Only' permissions.</Tooltip>}>
                                            <div>
                                              <img src={dashboardIcon} alt='' />
                                              Dashboards activity
                                            </div>
                                          </OverlayTrigger>
                                        )
                                        ||

                                        (!hasDashboards &&
                                          <OverlayTrigger placement="bottom"  overlay={<Tooltip className="tooltip_white">You cannot access dashboard activities because no dashboards have been assigned to your account.</Tooltip>}>
                                            <div>
                                              <img src={dashboardIcon} alt='' />
                                              Dashboards activity
                                            </div>
                                          </OverlayTrigger>
                                        )
                                        ||
                                        (u.pending &&
                                          <OverlayTrigger placement="bottom"  overlay={<Tooltip className="tooltip_white">You cannot access dashboard activities because their account is still pending approval.</Tooltip>}>
                                            <div>
                                              <img src={dashboardIcon} alt='' />
                                              Dashboards activity
                                            </div>
                                          </OverlayTrigger>
                                        )
                                      }
                                    </React.Fragment>
                                  }
                                </Button>

                                <AddUser model={u} onClose={this.getUsers}>
                                  <Button variant='secondary' className={`btn-icon ${isEditDisabled ? 'disabled' : ''}`} size='md' disabled={isEditDisabled}>
                                    {!u.pending && userId !== u.userId && !isOwnerInAnyAccount ?
                                      <img src={editIcon} alt="" />
                                      :
                                      <React.Fragment>
                                        {
                                          (u.pending &&
                                            <OverlayTrigger placement="bottom" overlay={<Tooltip className="tooltip_white">You cannot edit this user because their account is still pending approval.</Tooltip>}>
                                              <img src={editIcon} alt="" />
                                            </OverlayTrigger>
                                          )
                                          ||
                                          (userId === u.userId &&
                                            <OverlayTrigger placement="bottom" overlay={<Tooltip className="tooltip_white">You cannot edit your own user profile.</Tooltip>}>
                                              <img src={editIcon} alt="" />
                                            </OverlayTrigger>
                                          )
                                          ||
                                          (isOwnerInAnyAccount &&
                                            <OverlayTrigger placement="bottom" overlay={<Tooltip className="tooltip_white">You cannot modify the details of an owner account.</Tooltip>}>
                                             <img src={editIcon} alt="" />
                                            </OverlayTrigger>
                                          )
                                        }
                                      </React.Fragment>
                                    }
                                  </Button>
                                </AddUser>


                                <Confirm
                                  onConfirm={() => this.props.transferOwnership(u.userId)}
                                  body={
                                    <p>
                                      Are you sure you want to transfer <br />
                                      ownership to <strong>{u.email}</strong>?
                                    </p>
                                  }
                                  className="transfer-ownership"
                                  confirmText="Confirm"
                                  confirmClass="btn-primary"
                                  icon={transferIcon}
                                  title="Transfer ownership"
                                >
                                  <Button variant='secondary' size='md' className={`btn-icon ${isTransferDisabled ? 'disabled' : ''}`} disabled={isTransferDisabled}>
                                    {!isOwnerInAnyAccount && !u.pending && canTransferOwner ?
                                      <img src={transferIcon} alt='' />
                                      :
                                      <React.Fragment>
                                        {
                                          (isOwnerInAnyAccount &&
                                            <OverlayTrigger placement="bottom" overlay={<Tooltip className="tooltip_white">This user is already an account owner.</Tooltip>}>
                                              <img src={transferIcon} alt='' />
                                            </OverlayTrigger>
                                          )
                                          ||
                                          (u.pending &&
                                            <OverlayTrigger placement="bottom" overlay={<Tooltip className="tooltip_white">You cannot transfer ownership to a user whose account is still pending.</Tooltip>}>
                                              <img src={transferIcon} alt='' />
                                            </OverlayTrigger>
                                          )
                                          ||
                                          (!canTransferOwner &&
                                            <OverlayTrigger placement="bottom" overlay={<Tooltip className="tooltip_white">Only admins can transfer ownership. You do not have the necessary permissions to complete that action.</Tooltip>}>
                                              <img src={transferIcon} alt='' />
                                            </OverlayTrigger>
                                          )
                                        }
                                      </React.Fragment>
                                    }
                                  </Button>
                                </Confirm>


                                <Confirm
                                  onConfirm={() => this.props.deleteUser(u._id)}
                                  body={
                                    <p>
                                      Are you sure you want to remove <br />
                                      <strong>{u.name}</strong> from this account?
                                    </p>
                                  }
                                  confirmText="Remove"
                                  icon={deleteIcon}
                                  title="Remove user"
                                >
                                  <Button variant='danger' size='md' className={`btn-icon ${isDeleteDisabled  ? 'disabled' : ''}`} disabled={isDeleteDisabled}>
                                    {userId !== u.userId && !isOwnerInAnyAccount ?
                                      <img src={deleteIcon} alt="" />
                                      :
                                      <React.Fragment>
                                        {
                                          (u.isDeleting &&
                                            <OverlayTrigger placement="bottom" overlay={<Tooltip className="tooltip_white">User removal is in progress. Please wait until the process is complete.</Tooltip>}>
                                              <img src={deleteIcon} alt="" />
                                            </OverlayTrigger>
                                          )
                                          ||
                                          (userId === u.userId &&
                                            <OverlayTrigger placement="bottom" overlay={<Tooltip className="tooltip_white">You cannot remove your own account. Please contact another administrator.</Tooltip>}>
                                              <img src={deleteIcon} alt="" />
                                            </OverlayTrigger>
                                          )
                                          ||
                                          (isOwnerInAnyAccount &&
                                            <OverlayTrigger placement="bottom" overlay={<Tooltip className="tooltip_white">Owner accounts cannot be removed. Transfer ownership before proceeding.</Tooltip>}>
                                              <img src={deleteIcon} alt="" />
                                            </OverlayTrigger>
                                          )
                                        }
                                      </React.Fragment>
                                    }
                                  </Button>
                                </Confirm>

                              </React.Fragment>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>

            {total > 0 && this.renderPagination()}
          </div>
        </div>
        {isLoading && (
          <div className='table-loading loader-delay'>
            <Loading />
          </div>
        )}
      </React.Fragment>
    ];
  }
}

const mapDispatchToProps = dispatch => {
  return {
    exportCsv: opt => dispatch(exportCsv(opt)),
    getDashboards: () => dispatch(getDashboards()),
    getStreams: () => dispatch(getStreams()),
    getPortfolios: () => dispatch(getPortfolios()),
    getUsers: opt => dispatch(getUsers(opt)),
    deleteUser: id => dispatch(deleteUser(id)),
    resendInvitation: id => dispatch(resendInvitation(id)),
    rejectRequest: id => dispatch(rejectRequest(id)),
    transferOwnership: id => dispatch(transferOwnership(id))
  };
};

const mapStateToProps = state => {
  return {
    permissions: state.auth.user.permissions,
    dashboards: state.dashboards.list,
    streams: state.report.streams,
    portfolios: state.portfolio.portfolios,
    isLoading: state.users.loading,
    users: state.users.users,
    awaiting: state.users.awaiting,
    page: state.users.page,
    total: state.users.total,
    userId: state.auth.user._id
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Users));
